import { EpimsBaseEntityDto } from './epim-base.dto';
export class DamageAssessmentDetailsDto extends EpimsBaseEntityDto {

    DamageRefNo: string;
    DamagedId: string;
    DamagedQty: number;
    ClaimantRate: number;
    SpeculativeState: string;
    DemandedRate: number;
    AgreedNegotiatedRate: number;
    FromSP: string;
    ToSP: string;
    Status: string;
    Total: number;
    SwathNo: string;
    SwathId: string;
    DistanceCover: string;
    Claimant: string;
    ClaimantId: string;
    NewNegotiatedRate: number;
}